import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../../common/config";

export const getUserByIdService = createApi({
  reducerPath: "get user by id",
  baseQuery,
  endpoints: (builder) => ({
    getUserById: builder.query({
      query: (id) => ({
        url: `/api/users/resetpassword/${id}`,
        method: "GET",
      }),
    }),
  }),
});
export const { useGetUserByIdQuery } = getUserByIdService;
